module.exports = __webpack_public_path__ + "static/media/Video03.ec1760c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio/Video03.mp4
// module id = wOeZ
// module chunks = 0